import React, { type FC } from 'react'

import { Flex, FlexItem, NoResults } from 'mailup-web-components'
import { useIntl } from 'react-intl'

const NoChartData: FC = () => {
  const intl = useIntl()
  return (
    <Flex alignItems="center" justifyContent="center">
      <FlexItem flexBasis="67%" flexGrow="0">
        <NoResults
          margin="32px 0"
          text={intl.formatMessage({
            id: 'Load.RecipientsOverview.NoChartData',
          })}
        />
      </FlexItem>
    </Flex>
  )
}

export default NoChartData
